import React, { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);
    console.error("error boundary", error, errorInfo, this.props.log);
    if(error.toString().indexOf("can\'t access property \"findIndex\", v is undefined") > 0){
      console.warn("** DEV sCheck EqualHeightElement wrapped in EqualHeight **")
    }
    if (window.newrelic) {
      // const errorObject = new Error(
      //   `react problem:${
      //     this.props.log
      //   } error:${error}`
      // );

      // try {
      //   throw errorObject;
      // } catch (err) {
      //   console.log("noticeError", err, errorInfo);
      //   window.newrelic.noticeError(err, errorInfo);
      // }
      console.log("noticeError", error, errorInfo);
      window.newrelic.noticeError(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <div>Oops.</div>;
    }
    return this.props.children;
  }
}
